// ABOUTME: Support / life-buoy icon shown in the sidebar to open the Chatwoot support widget.
// ABOUTME: Clean outline style matching other sidebar icons; takes className, size, and color props.

import type { FC } from "react"

interface SupportHelpIconProps {
  className?: string
  size?: number
  color?: string
}

export const SupportHelpIcon: FC<SupportHelpIconProps> = ({ className, size = 20, color = "currentColor" }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <circle
        cx="12"
        cy="12"
        r="9"
        stroke={color}
        strokeWidth="2"
      />
      <circle
        cx="12"
        cy="12"
        r="3.5"
        stroke={color}
        strokeWidth="2"
      />
      <path
        d="M5.64 5.64l3.18 3.18"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M15.18 15.18l3.18 3.18"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M18.36 5.64l-3.18 3.18"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M8.82 15.18l-3.18 3.18"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  )
}
